import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=279314c3&scoped=true"
import script from "./PayResult.vue?vue&type=script&lang=js"
export * from "./PayResult.vue?vue&type=script&lang=js"
import style0 from "./PayResult.vue?vue&type=style&index=0&id=279314c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279314c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279314c3')) {
      api.createRecord('279314c3', component.options)
    } else {
      api.reload('279314c3', component.options)
    }
    module.hot.accept("./PayResult.vue?vue&type=template&id=279314c3&scoped=true", function () {
      api.rerender('279314c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CConfirm/PayResult.vue"
export default component.exports